import React, { useCallback } from 'react';
import { FilledInput, FormControl, InputLabel, MenuItem, Select } from 'housecall-ui';

import { PricingFormOptionType } from '../../types/types';

import { isNoUpperBound } from './utils';

type Props = {
  options: PricingFormOptionType[];
  label: string;
  value: string;
  onChange: (value: number) => void;
};

export const PricingFormRangeSelect = ({ value, onChange, options, label }: Props) => {
  const onSelect = useCallback(
    (event) => {
      onChange(event?.target.value);
    },
    [onChange]
  );

  return (
    <FormControl fullWidth variant="filled">
      <InputLabel>Options</InputLabel>
      <Select
        data-testid="pricing-form-single-select"
        fullWidth
        onChange={onSelect}
        value={value}
        input={<FilledInput fullWidth name={label} />}
      >
        {options.map((option: PricingFormOptionType) => {
          const noUpperBound = isNoUpperBound(option);
          return (
            <MenuItem key={option.id} data-testid={`menu-item-${option.id}`} value={option.id}>
              {noUpperBound ? `More than ${option.lowerBound}` : `${option.lowerBound} - ${option.upperBound}`}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
